/**
 * @generated SignedSource<<5c79f783ed52355652e88717dacdd384>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckInStatus = "CHECKED_IN" | "NONE" | "NO_SHOW";
export type ClientEventSignUpAccess = "ALREADY_IN_SERIES" | "CLOSED" | "COMPLETE" | "DRAFT" | "FULL" | "PENDING" | "SIGNUP_AVAILABLE" | "UNAVAILABLE" | "WAITLIST_AVAILABLE";
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
export type UpdateEventSignUpInput = {
  eventSignUp: InputForUpdateEventSignUp;
  eventSignUpId: string;
  notifyMember?: boolean | null | undefined;
};
export type InputForUpdateEventSignUp = {
  customerRegistrations?: ReadonlyArray<CustomerRegistrationInput | null | undefined> | null | undefined;
  guestRegistrations?: ReadonlyArray<GuestRegistrationInput | null | undefined> | null | undefined;
  memberRegistrations?: ReadonlyArray<MemberRegistrationInput | null | undefined> | null | undefined;
  newCustomerRegistrations?: ReadonlyArray<NewCustomerRegistrationInput | null | undefined> | null | undefined;
  newGuestRegistrations?: ReadonlyArray<NewGuestRegistrationInput | null | undefined> | null | undefined;
  ownerClientId?: string | null | undefined;
  paymentCardOnFileId?: string | null | undefined;
};
export type MemberRegistrationInput = {
  formResponses?: ReadonlyArray<EventFormResponseInput | null | undefined> | null | undefined;
  id?: string | null | undefined;
  index: number;
  payingMemberId: string;
  playerId?: string | null | undefined;
  primaryRegistrationChargeTypeId?: string | null | undefined;
};
export type EventFormResponseInput = {
  booleanValue?: boolean | null | undefined;
  eventRegistrationId?: string | null | undefined;
  questionConfigurationId: string;
  stringValue?: string | null | undefined;
  transportationTypeId?: string | null | undefined;
};
export type CustomerRegistrationInput = {
  formResponses?: ReadonlyArray<EventFormResponseInput | null | undefined> | null | undefined;
  id?: string | null | undefined;
  index: number;
  payingCustomerId?: string | null | undefined;
  playerId?: string | null | undefined;
  primaryRegistrationChargeTypeId?: string | null | undefined;
};
export type GuestRegistrationInput = {
  formResponses?: ReadonlyArray<EventFormResponseInput | null | undefined> | null | undefined;
  id?: string | null | undefined;
  index: number;
  payingMemberId: string;
  playerId?: string | null | undefined;
  primaryRegistrationChargeTypeId?: string | null | undefined;
};
export type NewGuestRegistrationInput = {
  email?: string | null | undefined;
  formResponses?: ReadonlyArray<EventFormResponseInput | null | undefined> | null | undefined;
  index: number;
  name: string;
  payingMemberId: string;
  playerId?: string | null | undefined;
  primaryRegistrationChargeTypeId?: string | null | undefined;
};
export type NewCustomerRegistrationInput = {
  email?: string | null | undefined;
  firstName: string;
  formResponses?: ReadonlyArray<EventFormResponseInput | null | undefined> | null | undefined;
  index: number;
  lastName: string;
  payingCustomerId?: string | null | undefined;
  phoneNumber?: string | null | undefined;
  primaryRegistrationChargeTypeId?: string | null | undefined;
};
export type useUpdateEventSignUpMutation$variables = {
  input: UpdateEventSignUpInput;
  memberId: string;
};
export type useUpdateEventSignUpMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly eventSignUp: {
      readonly checkedIn: CheckInStatus;
      readonly event: {
        readonly eventSeries: {
          readonly events: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly accessStatusForClient: ClientEventSignUpAccess | null | undefined;
                readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        };
        readonly " $fragmentSpreads": FragmentRefs<"EventDetailAttendeesList" | "EventDetailGroupDisplay_event" | "NewEventDetailAttendeesList" | "useCurrentSignUp_event" | "useInitEventSignUps_event">;
      };
      readonly id: string;
      readonly paymentCardOnFile: {
        readonly id: string;
      } | null | undefined;
      readonly waitlistIndex: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryContent_signUp">;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useUpdateEventSignUpMutation = {
  response: useUpdateEventSignUpMutation$data;
  variables: useUpdateEventSignUpMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waitlistIndex",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkedIn",
  "storageKey": null
},
v9 = [
  (v7/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareCardOnFile",
  "kind": "LinkedField",
  "name": "paymentCardOnFile",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v12 = {
  "alias": null,
  "args": (v11/*: any*/),
  "kind": "ScalarField",
  "name": "accessStatusForClient",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": (v11/*: any*/),
  "kind": "ScalarField",
  "name": "signUpStatusForClient",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canDelete",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unknownRegistrantDisplayName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "payingMember",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Customer",
  "kind": "LinkedField",
  "name": "payingCustomer",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": [
    {
      "alias": "publicId",
      "args": null,
      "kind": "ScalarField",
      "name": "renderingKey",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nationalNumber",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v29 = [
  (v27/*: any*/),
  (v28/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "booleanValue",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stringValue",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "TransportationType",
  "kind": "LinkedField",
  "name": "transportationType",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/)
  ],
  "type": "MemberEventRegistration",
  "abstractKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "EventSignUpWindow",
  "kind": "LinkedField",
  "name": "signUpWindow",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelDeadlineAt",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "EventFormResponseConnection",
  "kind": "LinkedField",
  "name": "formResponses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventFormResponseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventFormResponse",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v30/*: any*/),
            (v31/*: any*/),
            (v32/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FormQuestionConfiguration",
              "kind": "LinkedField",
              "name": "questionConfiguration",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enabled",
                  "storageKey": null
                },
                (v7/*: any*/),
                (v20/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "alias": "memberOwnerId",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v39 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayDescription",
  "storageKey": null
},
v41 = [
  (v27/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "type",
        "value": "GOLF"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "departmentMemberProfiles",
    "plural": true,
    "selections": [
      (v14/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ghinNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Department",
            "kind": "LinkedField",
            "name": "department",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "GolfMemberProfile",
        "abstractKey": null
      },
      (v7/*: any*/)
    ],
    "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateEventSignUpMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UpdateEventSignUpPayload",
        "kind": "LinkedField",
        "name": "updateEventSignUp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventSignUp",
            "kind": "LinkedField",
            "name": "eventSignUp",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSignupSummaryContent_signUp"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSeries",
                    "kind": "LinkedField",
                    "name": "eventSeries",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventConnection",
                        "kind": "LinkedField",
                        "name": "events",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v13/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EventDetailAttendeesList"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EventDetailGroupDisplay_event"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useCurrentSignUp_event"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useInitEventSignUps_event"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "NewEventDetailAttendeesList"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateEventSignUpMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UpdateEventSignUpPayload",
        "kind": "LinkedField",
        "name": "updateEventSignUp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventSignUp",
            "kind": "LinkedField",
            "name": "eventSignUp",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "EventRegistrationConnection",
                "kind": "LinkedField",
                "name": "registrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventRegistrationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventRegistrationChargeType",
                            "kind": "LinkedField",
                            "name": "primaryChargeType",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ChargeRuleSet",
                                "kind": "LinkedField",
                                "name": "chargeRuleSet",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 1
                                      }
                                    ],
                                    "concreteType": "ChargeRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "chargeRules",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ChargeRuleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ChargeRule",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v18/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "chargeRules(first:1)"
                                  },
                                  (v7/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v21/*: any*/),
                              (v22/*: any*/)
                            ],
                            "type": "GuestEventRegistration",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v21/*: any*/),
                              (v23/*: any*/)
                            ],
                            "type": "CustomerEventRegistration",
                            "abstractKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "registrant",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v7/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v29/*: any*/),
                                "type": "Member",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v29/*: any*/),
                                "type": "Customer",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v17/*: any*/),
                            "concreteType": "EventFormResponseConnection",
                            "kind": "LinkedField",
                            "name": "formResponses",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventFormResponseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventFormResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FormQuestionConfiguration",
                                        "kind": "LinkedField",
                                        "name": "questionConfiguration",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v20/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "prompt",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "formResponses(first:50)"
                          },
                          (v33/*: any*/),
                          (v34/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "registrations(first:50)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "active",
                    "value": true
                  }
                ],
                "concreteType": "OrderConnection",
                "kind": "LinkedField",
                "name": "orders",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Order",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "total",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTaxes",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "orders(active:true)"
              },
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryChargeType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prePaymentRequirement",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSeries",
                    "kind": "LinkedField",
                    "name": "eventSeries",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isEventPrePaymentEnabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityCopyOverrides",
                            "kind": "LinkedField",
                            "name": "copyOverrides",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NounOverride",
                                "kind": "LinkedField",
                                "name": "eventPlayer",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "singular",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Club",
                            "kind": "LinkedField",
                            "name": "club",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "supportsPublic",
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventConnection",
                        "kind": "LinkedField",
                        "name": "events",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spotsAvailable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "capacityType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxGuestCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxMemberCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minMemberCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minGuestCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "capacity",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasWaitlist",
                    "storageKey": null
                  },
                  {
                    "alias": "eventSignUps",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "waitlist",
                        "value": false
                      }
                    ],
                    "concreteType": "EventSignUpConnection",
                    "kind": "LinkedField",
                    "name": "signUps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUpEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventSignUp",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventRegistrationConnection",
                                "kind": "LinkedField",
                                "name": "registrations",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "count",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventRegistrationEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          (v7/*: any*/),
                                          (v20/*: any*/),
                                          (v33/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "registrant",
                                            "plural": false,
                                            "selections": [
                                              (v14/*: any*/),
                                              (v7/*: any*/),
                                              (v24/*: any*/),
                                              (v25/*: any*/),
                                              (v26/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v36/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "signUps(waitlist:false)"
                  },
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "EventSignUp",
                    "kind": "LinkedField",
                    "name": "signUpForClient",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v15/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "ownerClient",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v37/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v38/*: any*/),
                              (v26/*: any*/)
                            ],
                            "type": "Member",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v38/*: any*/),
                              (v26/*: any*/)
                            ],
                            "type": "Customer",
                            "abstractKey": null
                          },
                          (v39/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventRegistrationConnection",
                        "kind": "LinkedField",
                        "name": "registrations",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventRegistrationEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v7/*: any*/),
                                  (v20/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v22/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "type": "GuestEventRegistration",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v23/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "type": "CustomerEventRegistration",
                                    "abstractKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventRegistrationChargeType",
                                    "kind": "LinkedField",
                                    "name": "primaryChargeType",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ChargeRuleSet",
                                        "kind": "LinkedField",
                                        "name": "chargeRuleSet",
                                        "plural": false,
                                        "selections": [
                                          (v19/*: any*/),
                                          (v40/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "registrant",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v7/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v41/*: any*/),
                                        "type": "Member",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v41/*: any*/),
                                        "type": "Customer",
                                        "abstractKey": null
                                      },
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v36/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "memberSignUpProxyAllowed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "EventSignUpWindow",
                    "kind": "LinkedField",
                    "name": "clientEligibleSignUpWindows",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUpWindowChargesConnection",
                        "kind": "LinkedField",
                        "name": "charges",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventSignUpWindowChargesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "memberControl",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventRegistrationChargeType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ChargeRuleSet",
                                    "kind": "LinkedField",
                                    "name": "chargeRuleSet",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v19/*: any*/),
                                      (v40/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ChargeRuleConnection",
                                        "kind": "LinkedField",
                                        "name": "chargeRules",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ChargeRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ChargeRule",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "duration",
                                                    "storageKey": null
                                                  },
                                                  (v18/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "billingId",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "description",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "ownerClient",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v37/*: any*/)
                    ],
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v39/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "95d498701f4f0d86ed7f6fd40046bdf1",
    "id": null,
    "metadata": {},
    "name": "useUpdateEventSignUpMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateEventSignUpMutation(\n  $input: UpdateEventSignUpInput!\n  $memberId: ID!\n) {\n  responsePayload: updateEventSignUp(input: $input) {\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    success\n    eventSignUp {\n      waitlistIndex\n      id\n      checkedIn\n      paymentCardOnFile {\n        id\n      }\n      ...EventSignupSummaryContent_signUp\n      event {\n        eventSeries {\n          events {\n            edges {\n              node {\n                accessStatusForClient(clientId: $memberId)\n                signUpStatusForClient(clientId: $memberId)\n                id\n              }\n            }\n          }\n          id\n        }\n        ...EventDetailAttendeesList\n        ...EventDetailGroupDisplay_event\n        ...useCurrentSignUp_event\n        ...useInitEventSignUps_event\n        ...NewEventDetailAttendeesList\n        id\n      }\n    }\n  }\n}\n\nfragment EventDetailAttendeesGroupListItemFragment on EventSignUp {\n  waitlistIndex\n  id\n  checkedIn\n  registrations {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        formResponses {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                enabled\n                id\n                type\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventDetailAttendeesList on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  spotsAvailable\n  capacityType\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  capacity\n  hasWaitlist\n  eventSeries {\n    facility {\n      copyOverrides {\n        eventPlayer {\n          singular\n        }\n      }\n      id\n    }\n    id\n  }\n  eventSignUps: signUps(waitlist: false) {\n    edges {\n      node {\n        id\n        registrations {\n          count\n        }\n        ...EventDetailAttendeesListItemFragment\n        ...EventDetailAttendeesGroupListItemFragment\n      }\n    }\n  }\n}\n\nfragment EventDetailAttendeesListItemFragment on EventSignUp {\n  waitlistIndex\n  id\n  checkedIn\n  registrations {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        formResponses {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                enabled\n                id\n                type\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventDetailGroupDisplay_event on Event {\n  ...useCurrentSignUp_event\n  id\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  primaryChargeType\n  memberSignUpProxyAllowed\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    charges {\n      edges {\n        memberControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            displayDescription\n            chargeRules {\n              edges {\n                node {\n                  id\n                  duration\n                  price\n                  billingId\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventSignupSummaryActions_signUp on EventSignUp {\n  id\n  canDelete\n  status\n  waitlistIndex\n  checkedIn\n  signUpWindow {\n    cancelDeadlineAt\n    id\n  }\n  ownerClient {\n    __typename\n    ... on Member {\n      id\n      memberOwnerId: id\n    }\n    ... on Customer {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        ... on MemberEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on GuestEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        primaryChargeType {\n          id\n        }\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          ... on Member {\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            email\n          }\n          ... on Customer {\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            email\n          }\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventSignupSummaryContent_signUp on EventSignUp {\n  id\n  canDelete\n  status\n  waitlistIndex\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n      }\n    }\n  }\n  signUpWindow {\n    cancelDeadlineAt\n    id\n  }\n  ...EventSignupSummaryPlayerList_signUp\n  ...EventSignupSummaryTotal_signUp\n  ...EventSignupSummaryPaymentSummary_signUp_9obry\n  ...EventSignupSummaryReservation_signUp_9obry\n  ...EventSignupSummaryActions_signUp\n}\n\nfragment EventSignupSummaryPaymentSummary_signUp_9obry on EventSignUp {\n  id\n  status\n  waitlistIndex\n  event {\n    id\n    prePaymentRequirement\n    eventSeries {\n      facility {\n        id\n        isEventPrePaymentEnabled\n      }\n      id\n    }\n    primaryChargeType\n  }\n  paymentCardOnFile {\n    id\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        ... on MemberEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on GuestEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on CustomerEventRegistration {\n          payingCustomer {\n            id\n          }\n        }\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  price\n                  id\n                }\n              }\n            }\n            id\n          }\n        }\n        registrant {\n          __typename\n          id\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n      }\n    }\n  }\n  ...EventSignupSummaryTotal_signUp\n}\n\nfragment EventSignupSummaryPlayerList_signUp on EventSignUp {\n  registrations(first: 50) {\n    edges {\n      node {\n        id\n        __typename\n        type\n        ... on GuestEventRegistration {\n          unknownRegistrantDisplayName\n        }\n        ... on CustomerEventRegistration {\n          unknownRegistrantDisplayName\n        }\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            displayName\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n            id\n          }\n        }\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              questionConfiguration {\n                id\n                type\n                prompt\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventSignupSummaryReservation_signUp_9obry on EventSignUp {\n  id\n  status\n  waitlistIndex\n  event {\n    id\n    prePaymentRequirement\n    eventSeries {\n      facility {\n        id\n        isEventPrePaymentEnabled\n      }\n      id\n    }\n    primaryChargeType\n  }\n  paymentCardOnFile {\n    id\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        ... on MemberEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on GuestEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on CustomerEventRegistration {\n          payingCustomer {\n            id\n          }\n        }\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  price\n                  id\n                }\n              }\n            }\n            id\n          }\n        }\n        registrant {\n          __typename\n          id\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n      }\n    }\n  }\n}\n\nfragment EventSignupSummaryTotal_signUp on EventSignUp {\n  status\n  event {\n    id\n    primaryChargeType\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            displayName\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n      }\n    }\n  }\n}\n\nfragment NewEventDetailAttendeesGroupListItemFragment on EventSignUp {\n  id\n  registrations {\n    edges {\n      node {\n        __typename\n        id\n        type\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NewEventDetailAttendeesList on Event {\n  id\n  capacityType\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  eventSeries {\n    facility {\n      copyOverrides {\n        eventPlayer {\n          singular\n        }\n      }\n      id\n    }\n    id\n  }\n  eventSignUps: signUps(waitlist: false) {\n    edges {\n      node {\n        id\n        registrations {\n          count\n        }\n        ...NewEventDetailAttendeesListItemFragment\n        ...NewEventDetailAttendeesGroupListItemFragment\n      }\n    }\n  }\n}\n\nfragment NewEventDetailAttendeesListItemFragment on EventSignUp {\n  id\n  registrations {\n    edges {\n      node {\n        __typename\n        id\n        type\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useCurrentSignUp_event on Event {\n  signUpForClient(clientId: $memberId) {\n    signUpWindow {\n      cancelDeadlineAt\n      id\n    }\n    waitlistIndex\n    id\n    canDelete\n    checkedIn\n    ownerClient {\n      __typename\n      ... on Member {\n        id\n        memberOwnerId: id\n        firstName\n        lastName\n        fullName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Customer {\n        id\n        fullName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    registrations {\n      edges {\n        node {\n          __typename\n          id\n          type\n          index\n          ... on MemberEventRegistration {\n            payingMember {\n              id\n            }\n          }\n          ... on GuestEventRegistration {\n            payingMember {\n              id\n            }\n            unknownRegistrantDisplayName\n          }\n          ... on CustomerEventRegistration {\n            payingCustomer {\n              id\n            }\n            unknownRegistrantDisplayName\n          }\n          primaryChargeType {\n            id\n            chargeRuleSet {\n              displayName\n              displayDescription\n              id\n            }\n          }\n          registrant {\n            __typename\n            id\n            firstName\n            lastName\n            profileImage {\n              publicId: renderingKey\n            }\n            ... on Member {\n              phoneNumber {\n                nationalNumber\n                id\n              }\n              departmentMemberProfiles(type: GOLF) {\n                __typename\n                ... on GolfMemberProfile {\n                  ghinNumber\n                  department {\n                    slug\n                    id\n                  }\n                }\n                id\n              }\n            }\n            ... on Customer {\n              phoneNumber {\n                nationalNumber\n                id\n              }\n              departmentMemberProfiles(type: GOLF) {\n                __typename\n                ... on GolfMemberProfile {\n                  ghinNumber\n                  department {\n                    slug\n                    id\n                  }\n                }\n                id\n              }\n            }\n            email\n          }\n          formResponses {\n            edges {\n              node {\n                id\n                booleanValue\n                stringValue\n                transportationType {\n                  id\n                }\n                questionConfiguration {\n                  enabled\n                  id\n                  type\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useInitEventSignUps_event on Event {\n  memberSignUpProxyAllowed\n  ...useCurrentSignUp_event\n  signUpStatusForClient(clientId: $memberId)\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "797825e0ce01dfec72f2128fd57ec146";

export default node;
